import React, { useState, useEffect } from 'react';
import ChevronDown from '@panel/commons/assets/icons/ChevronDown.svg';
import ChevronUp from '@panel/commons/assets/icons/ChevronUp.svg';
import { sendTrackingInfo } from '@panel/commons';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { InboxOperations } from '@panel/leads/src/components/menuInbox/ducks';
import { FilterOperations } from '../../../ducks/filter/index';
import { FacetModuleContainer, FacetItem } from './styles';
import { getTranslationByKey } from '../../../helpers/datalayerTranslate';

const FacetModule = ({
  facet,
  translate,
  isDesktop = false,
  facetsWithCompositeKey,
  filterUpdateFormat,
  setUrlSearch
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(isDesktop);
  const { values, facetName } = facet;
  const [valuesKeys, setValuesKeys] = useState([]);
  const [facetItemsLimited, setFacetItemsLimited] = useState(isDesktop);
  const [activeHover, setActiveHover] = useState(false);

  useEffect(() => {
    setValuesKeys(facetItemsLimited ? Object.keys(values).splice(0, 5) : Object.keys(values));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facetItemsLimited, values]);

  function facetIdFormatter(facetItem) {
    const slicedItem = facetItem.split(',');
    return slicedItem;
  }

  function handleApplyFilter(key, filterName) {
    dispatch(InboxOperations.fetchUnread('nondiscarded', false));
    // seteamos el filtro en la url para mantener los filtros aplicados al recargar el navegador:
    setUrlSearch(key, filterName);
    const dataLayerText = `Filtro-${getTranslationByKey(filterName)}_${getTranslationByKey(
      facetsWithCompositeKey.includes(facetName) ? key[1] : key[0]
    )}`;

    sendTrackingInfo('Panel', 'Mis avisos', dataLayerText);

    dispatch(FilterOperations.update(filterUpdateFormat(key, filterName)));
  }

  return (
    <FacetModuleContainer isExpanded={isExpanded} facetItemsLimited={facetItemsLimited} active={activeHover}>
      <div
        className='facet-title'
        data-panel='filter-facetModule-title'
        onClick={() => !isDesktop && setIsExpanded(!isExpanded)}
        aria-hidden='true'
      >
        <p data-panel={`filterBy-${facetName}`}>{t(`panel.avisos.filters.${facetName}`)}</p>
        {!isDesktop && <img src={isExpanded ? ChevronUp : ChevronDown} alt='Flecha de direccion' />}
      </div>
      {valuesKeys &&
        valuesKeys.map(item => {
          const formatedItem = facetIdFormatter(item);
          const quantity = values[item];
          const facetItemName = facetsWithCompositeKey.includes(facetName)
            ? formatedItem[1]
            : translate(formatedItem[0], facetName);
          return (
            <FacetItem
              data-panel={`filter-facetModule-facet-${facetItemName}`}
              key={formatedItem[0]}
              onClick={() => handleApplyFilter(formatedItem, facetName)}
            >
              {facetItemName} ({quantity})
            </FacetItem>
          );
        })}
      {isDesktop && Object.keys(values).length > 5 && (
        <div
          className='see-more-less'
          data-panel='filter-seeMoreLess-mobile'
          onClick={() => setFacetItemsLimited(!facetItemsLimited)}
          onMouseOver={() => setActiveHover(true)}
          onFocus={() => setActiveHover(true)}
          onMouseLeave={() => setActiveHover(false)}
          aria-hidden='true'
        >
          {facetItemsLimited ? 'Ver más' : 'Ver menos'}
          <div className='seeMoreLess-icon' data-panel='filter-seeMoreLess-icon' />
        </div>
      )}
    </FacetModuleContainer>
  );
};

export default FacetModule;
